import { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../setup'
import {toAbsoluteUrl} from './AssetHelpers'

export const modifyDashboardIconsURL = ( iconType:string, path:string) => {
  return path.replaceAll('{iconType}' , iconType);
}
